import _styled from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { observer } from "mobx-react";
import { Fragment } from "react";
import ChartView from "../../Charts/ChartView";
import filterOutUndefined from "../../Core/filterOutUndefined";
import hasTraits from "../../Models/Definition/hasTraits";
import DiscretelyTimeVaryingTraits from "../../Traits/TraitsClasses/DiscretelyTimeVaryingTraits";
import parseCustomHtmlToReact from "../Custom/parseCustomHtmlToReact";
import Box from "../../Styled/Box";
import Spacing from "../../Styled/Spacing";
import Text from "../../Styled/Text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ChartDisclaimer = _ref => {
  let {
    terria
  } = _ref;
  const chartView = new ChartView(terria);
  const uniqueChartDisclaimers = [...new Set(filterOutUndefined(chartView.chartItems.map(chartItem => chartItem.showInChartPanel && hasTraits(chartItem.item, DiscretelyTimeVaryingTraits, "chartDisclaimer") ? chartItem.item.chartDisclaimer : undefined)))];
  if (uniqueChartDisclaimers.length === 0) return null;
  return /*#__PURE__*/_jsxs(_StyledBox, {
    backgroundColor: "#9a4b4b",
    column: true,
    paddedHorizontally: 2,
    children: [/*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    }), uniqueChartDisclaimers.map(chartDisclaimer => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        textLight: true,
        children: parseCustomHtmlToReact(chartDisclaimer)
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      })]
    }, chartDisclaimer))]
  });
};
export default observer(ChartDisclaimer);
var _StyledBox = _styled(Box).withConfig({
  displayName: "ChartDisclaimer___StyledBox",
  componentId: "sc-2z9hz0-0"
})(["a,a:visited{color:white;}"]);